import { Component, Host, h, Prop, Element, State, Listen } from '@stencil/core';

@Component({
  tag: 'bam-quick-link-nav',
  styleUrl: 'bam-quick-link-nav.scss',
  shadow: false,
})
export class BamQuickLinkNav {
  @Element() host: HTMLBamQuickLinkNavElement;
  @Prop() headline: string;
  @Prop() backgroundColor: 'purple' | 'red' | 'green' | 'yellow';
  // TODO: replace window.innerWidth > 1023 with isPlatform(window, 'desktop')
  @State() isDesktop: boolean = window.innerWidth > 1023;

  @Listen('resize', { target: 'window' })
  handleResize() {
    this.isDesktop = window.innerWidth > 1023;
  }

  render() {
    return (
      <Host>
        <div class="bam-quick-link-nav__container mt-xx-large">
          <bal-card class="bam-quick-link-nav__card m-none" space="medium" color={this.backgroundColor}>
            <bal-card-content>
              <div class="grid">
                {this.headline && (
                  <bal-heading
                    class={{
                      'bam-quick-link-nav__heading col': true,
                      'is-one-third': !this.isDesktop,
                      'is-one-quarter': this.isDesktop,
                    }}
                    level="h4"
                    space="none"
                  >
                    {this.headline}
                  </bal-heading>
                )}
                <slot name="list"></slot>
              </div>
            </bal-card-content>
          </bal-card>
        </div>
      </Host>
    );
  }
}
